import Button from "components/_button/form/action";
import MainFormContext from "context/main-form";
import { useGetCity } from "hooks/useRequest/location/location";
import { useUpdateProject } from "hooks/useRequest/project/projectRequest";
import { useRouter } from "next/router";
import {
  ChangeEvent,
  memo,
  useCallback,
  useContext,
  useState,
} from "react";
import ReactGA from 'react-ga';
import { toast } from "react-toastify";
import ProjectItemEnum from "rules/enums/project/project-item.enum";
import IProjectTypes from "rules/interface/project/project-types.interface";
import cityService from "services/city.service";
import LastProjectService from "services/last-project";
import selectedContractorService from "services/selected-contractor.service";
import formStyles from "../steps.module.scss";
import styles from "./index.module.scss";
import FormTypesItem from "./items";





const FormProjectTypeStep = () => {
  const { values, setValues } = useContext(MainFormContext)
  const router = useRouter()
  const city = cityService.getCity();

  const aghsatiQs = ["insta-aghsat", "aghsat-cabinet1", "aghsat-cabinet-popup"]

  const isAghsati = Boolean(aghsatiQs.includes((router.query?.form_type as string)))

  const [projectType, setProjectType] = useState<IProjectTypes[]>(values.projectItems ?? [])

  const [shakeItems, setShakeItems] = useState<boolean>(false)

  const { mutateAsync, isLoading } = useUpdateProject()

  const { data } = useGetCity({
    city: city?._id as string,
    enabled: Boolean(city?._id),
  });

  const selectedContractor = selectedContractorService.getContractors()


  const changeHandler = useCallback((e: ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value as ProjectItemEnum
    const array = projectType;


    // if new item is exist in array
    if (array.find(res => value === res.itemName)) {
      const newObj = array.filter(res => res.itemName !== value)
      setProjectType(newObj)

    } else { // if new item not exist in array
      setProjectType(prev => [...prev, { itemName: value }])
    }

  }, [projectType])



  const handleNextStep = useCallback((projectDetails: boolean) => {
    try {
      if (projectType?.length > 0) {
        
        if (!values.withinGoal) {
          ReactGA.event({
            category: 'Submit',
            action: 'Click',
            label: projectDetails ? 'form-choose-project-type' : "form-choose-project-type-selected-contractor"
          });
        }

        mutateAsync({
          id: LastProjectService.getId(),
          data: {
            projectItems: projectType
          }
        })
          .then(() => {
            setValues(prev => ({ ...prev, projectItems: projectType }))

            if (projectDetails) values.nextStep()
            else {
              if (isAghsati) router.push("https://slmsa.landin.ir/aqsat14023/?utm_source=form&utm_medium=referral&utm_campaign=aghsat&utm_content=product-page");
              else router.push(
                data?.data?.countOfContractors > 0
                  ?
                  city?.class ?
                    `/contractors/cities/${data?.data?.alias}?filters={"sortBaseOn":"usersRecommendation"}`
                    :
                    `/contractors/cities/${data?.data?.alias}?filters={"sortBaseOn":"usersRecommendation","canBeSelectByCustomer":"true"}`
                  : `/contractors?filters={"canBeSelectByCustomer":"true","sortBaseOn":"usersRecommendation"}`
              );
            }
          })
          .catch(err => {
            toast.dark(err.response?.data?.message ?? "ارسال اطلاعات با مشکل مواجه شد، لطفا دوباره تلاش کنید")
          })
      }
      else {
        setShakeItems(true)

        setTimeout(() => {
          setShakeItems(false)
        }, 1000)
      }
    } catch {
      toast.dark("مشکلی بوجود آمده است، لطفا به پشتیبان گزارش دهید")
    }
  }, [values, projectType])




  return (
    <div className={styles.project_type + " flex flex-column jcb flex-grow gap-20"}>
      <h4 className={formStyles.form_title + ` fw-700`}>
        <span className={styles.type_writer_title}>
          نوع پروژه خود را انتخاب کنید
        </span>
      </h4>

      <div className="flex flex-column gap-5">

        <FormTypesItem value={projectType} onChange={changeHandler} shake={shakeItems} />

      </div>


      <div className={styles.footer__project_type + ' flex flex-column gap-10 jcb mt-xl'}>

        {
          selectedContractor?.length <= 0 ?
            <>
              {
                isAghsati ?
                  <>
                    <div className={styles.content__footer}>
                      <p>
                        برای اطلاع از <span className="fw-900">شرایط اقساطی</span>، دکمه‌ی زیر را کلیک کنید.
                      </p>
                    </div>

                    <Button
                      id="form-choose-project-type-selected-contractor"
                      loading={isLoading}
                      onClick={() => handleNextStep(false)}
                      className={styles.select_contractor__footer + ` ${projectType?.length <= 0 ? styles.disabled : ""}`}
                      animation
                    >
                      اطلاع از شرایط اقساطی
                    </Button>
                  </>
                  :
                  <>
                    <div className={styles.content__footer}>
                      <p>
                        در ادامه شما می توانید با مشاهده <span className="fw-900">پروفایل</span> متخصصین، متخصص مناسب خود را انتخاب کنید و <span className="fw-900">قرار بازدید رایگان</span> بگذارید.
                      </p>
                    </div>

                    <Button
                      id="form-choose-project-type-selected-contractor"
                      loading={isLoading}
                      onClick={() => handleNextStep(false)}
                      className={styles.select_contractor__footer + ` ${projectType?.length <= 0 ? styles.disabled : ""}`}
                      animation
                    >
                      انتخاب متخصص
                    </Button>
                  </>
              }
            </>
            :
            <Button
              id="form-choose-project-type"
              className={styles.submit_detail_btn__footer + ` flex-grow ${projectType?.length <= 0 ? styles.disabled : ""}`}
              onClick={() => handleNextStep(true)}
              loading={isLoading}
              btnType="bordered"
            >
              ثبت جزئیات پروژه
            </Button>
        }

      </div>


    </div>
  );
};

export default memo(FormProjectTypeStep);
